var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard_active",
    transform: "translate(-429 -178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Two-tone_Category",
    "data-name": "Iconly/Two-tone/Category",
    transform: "translate(427.99 176.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Category",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M0,3.893C0,.973.032,0,3.894,0S7.786.973,7.786,3.893,7.8,7.785,3.894,7.785,0,6.812,0,3.893Z",
    transform: "translate(-0.001 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    d: "M11,3.893C11,.973,11.032,0,14.894,0s3.893.973,3.893,3.893.012,3.893-3.893,3.893S11,6.812,11,3.893Z",
    transform: "translate(1.233 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-5",
    d: "M0,14.893C0,11.973.032,11,3.894,11s3.893.973,3.893,3.893.012,3.893-3.893,3.893S0,17.812,0,14.893Z",
    transform: "translate(-0.001 1.234)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-7",
    d: "M11,14.893c0-2.92.031-3.893,3.893-3.893s3.893.973,3.893,3.893.012,3.893-3.893,3.893S11,17.812,11,14.893Z",
    transform: "translate(1.233 1.234)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1079",
    "data-name": "Rectangle 1079",
    width: 24,
    height: 24,
    transform: "translate(429 178)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.5be88b1fdd9c9666d58bb1f7ff023063.svg";
export { ForwardRef as ReactComponent };